import { Button, Modal, Stack, Text, Title } from "@mantine/core"
import { useNavigate } from "react-router-dom"
import {
	AEM_DICTIONARY_COLLECTIONS,
	useAEMDictionary
} from "@AEM/hooks/useAEMDictionary"
import {
	COMPLIANCE_INTENDED_PATH_STORAGE_KEY,
	COMPLIANCE_COMPLETE_MODAL_SHOWN_KEY,
	DEFAULT_INTENDED_PATH
} from "@utils/constants.util"
import styles from "./ComplianceRequiredModal.module.css"

interface ComplianceCompleteModalProps {
	opened: boolean
	onClose: () => void
}

export function ComplianceCompleteModal({
	opened,
	onClose
}: ComplianceCompleteModalProps) {
	const { dictionary } = useAEMDictionary(
		AEM_DICTIONARY_COLLECTIONS.REGISTRATION
	)
	const navigate = useNavigate()

	const handleCta = () => {
		const intendedPath =
			sessionStorage.getItem(COMPLIANCE_INTENDED_PATH_STORAGE_KEY) ||
			DEFAULT_INTENDED_PATH
		sessionStorage.removeItem(COMPLIANCE_INTENDED_PATH_STORAGE_KEY)
		sessionStorage.setItem(COMPLIANCE_COMPLETE_MODAL_SHOWN_KEY, "1")
		onClose()
		navigate(intendedPath, { replace: true })
	}

	return (
		<Modal.Root
			opened={opened}
			onClose={onClose}
			centered
			size={700}
			closeOnClickOutside={false}
			closeOnEscape={false}
			classNames={{ content: styles.modalContent }}
			zIndex={500}
		>
			<Modal.Overlay opacity={0} />
			<Modal.Content>
				<Modal.Header p="10px 0" w="100%">
					<Stack align="center" p="26px" w="100%">
						<Title order={1} fz={{ base: 26, sm: 26 }} fw={600} ta="center">
							{dictionary?.hsCompleteModelTitle ?? ""}
						</Title>
					</Stack>
				</Modal.Header>
				<Modal.Body p={0}>
					<Stack
						w="100%"
						gap={0}
						maw={780}
						p={{ base: "0 24px 32px", sm: "0 50px 40px 50px" }}
					>
						<Text fz={{ base: 14, sm: 16 }} lh={1.5}>
							{dictionary?.hsCompleteModelDescription1 ?? ""}
						</Text>
						{dictionary?.hsCompleteModelDescription2 ? (
							<Text fz={{ base: 14, sm: 16 }} lh={1.5} mt="sm">
								{dictionary?.hsCompleteModelDescription2 ?? ""}
							</Text>
						) : null}
					</Stack>
					<Stack align="center" p="20px 0 40px 0" w="100%">
						<Button size="lg" variant="dark-blue" onClick={handleCta}>
							{dictionary?.goToHomePage ?? ""}
						</Button>
					</Stack>
				</Modal.Body>
			</Modal.Content>
		</Modal.Root>
	)
}
